import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

import Obr from "../images/katherine-volkovski-Q_MJjEN14uk-unsplash.jpg"

const SecondPage = () => (
  <Layout>
    <SEO title="Hybrid kukurice Pyroxenia" />
    <section className="text-gray-700 body-font overflow-hidden">
      <div className="container px-5 py-24 mx-auto">
        <div className="lg:w-4/5 mx-auto flex flex-wrap">
          <div className="lg:w-1/2 w-full lg:pr-10 lg:py-6 mb-6 lg:mb-0">
            <h2 className="text-sm title-font text-gray-500 tracking-widest">
              FAO 130
            </h2>
            <h1 className="text-gray-900 text-3xl title-font font-medium mb-4">
              Pyroxenia
            </h1>
            <div className="flex mb-4">
              <span className="flex-grow text-indigo-500 border-b-2 border-indigo-500 py-2 text-lg px-1">
                Odporúčania pre pestovateľov
              </span>
            </div>
            <p className="leading-relaxed text-justify mb-4">
              Hybrid PYROXENIA je vzhľadom na svoju extrémnu superskorosť vhodný
              pre pestovanie na kukurice na siláž do chladnejších podmienok
              horskej výrobnej oblasti. S možnosťou sejby v druhej polovici mája
              po období neskorých jarných mrazíkov a zberom na siláž koncom
              augusta pred príchodom prvých jesenných mrazíkov. Vzhľadom na
              nižší habitus a relatívne vyšší pomer šúľkov k celej rastline
              odporúčame jeho vyššie zahustenie na 120 000 rastlín na hektár a v
              prípade dobre živinami a vodou zásobených pôd aj na 130 000
              rastlín na hektár. V prípade uplatnenia CCM a LKS však treba
              prispôsobiť organizáciu porastu na 100 000 rastlín na hektár. V
              teplejších humídnych oblastiach možno odporučiť vzhľadom na
              extrémnu superskorosť aj možnosť využitia pre pestovanie kukurice
              ako medziplodiny.
            </p>
            <div className="flex border-t border-gray-300 py-2">
              <span className="text-gray-500">Typ hybridu</span>
              <span className="ml-auto text-gray-900">Tc</span>
            </div>
            <div className="flex border-t border-gray-300 py-2">
              <span className="text-gray-500">Typ zrna</span>
              <span className="ml-auto text-gray-900">medzityp</span>
            </div>

            <div className="flex py-2">
              <span className="title-font font-medium text-2xl text-gray-900">
                Organizácia porastu:
              </span>
            </div>
            <div className="flex border-t border-gray-300 py-2">
              <span className="text-gray-500">Pre pestovanie na siláž </span>
              <span className="ml-auto text-gray-900">
                120 000 <br />
                <span className="text-xs">rastlín na ha</span>
              </span>
            </div>
            <div className="flex border-t border-gray-300 py-2 mb-6">
              <span className="text-gray-500">Pre pestovanie na CCM, LKS </span>
              <span className="ml-auto text-gray-900">
                100 000 <br />
                <span className="text-xs">rastlín na ha</span>
              </span>
            </div>

            <div className="flex py-2">
              <span className="title-font font-medium text-2xl text-gray-900">
                Hospodárske vlastnosti:
              </span>
            </div>

            <div className="flex border-gray-300">
              <div className="p-2  w-full">
                <div className="bg-gray-200 rounded flex p-4 h-full items-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3"
                    className="text-indigo-500 w-6 h-6 flex-shrink-0 mr-4"
                    viewBox="0 0 24 24"
                  >
                    <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
                    <path d="M22 4L12 14.01l-3-3"></path>
                  </svg>
                  <span className="title-font font-medium">
                    Extrémna skorosť pre pestovanie kukurice na siláž v horských
                    oblastiach
                  </span>
                </div>
              </div>
            </div>

            <div className="flex border-t border-gray-300">
              <div className="p-2  w-full">
                <div className="bg-gray-200 rounded flex p-4 h-full items-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3"
                    className="text-indigo-500 w-6 h-6 flex-shrink-0 mr-4"
                    viewBox="0 0 24 24"
                  >
                    <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
                    <path d="M22 4L12 14.01l-3-3"></path>
                  </svg>
                  <span className="title-font font-medium">
                    Relatívne vyšší podiel šúľkov{" "}
                  </span>
                </div>
              </div>
            </div>

            <div className="flex border-t border-gray-300">
              <div className="p-2  w-full">
                <div className="bg-gray-200 rounded flex p-4 h-full items-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3"
                    className="text-indigo-500 w-6 h-6 flex-shrink-0 mr-4"
                    viewBox="0 0 24 24"
                  >
                    <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
                    <path d="M22 4L12 14.01l-3-3"></path>
                  </svg>
                  <span className="title-font font-medium">
                    Adaptabilita k vyššiemu zahusteniu porastu{" "}
                  </span>
                </div>
              </div>
            </div>

            <div className="flex border-t border-gray-300">
              <div className="p-2  w-full">
                <div className="bg-gray-200 rounded flex p-4 h-full items-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3"
                    className="text-indigo-500 w-6 h-6 flex-shrink-0 mr-4"
                    viewBox="0 0 24 24"
                  >
                    <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
                    <path d="M22 4L12 14.01l-3-3"></path>
                  </svg>
                  <span className="title-font font-medium">
                    Rýchly nárast sušiny šúľkov pred príchodom skorých jesenných
                    mrazíkov
                  </span>
                </div>
              </div>
            </div>

            <div className="flex border-t border-gray-300">
              <div className="p-2  w-full">
                <div className="bg-gray-200 rounded flex p-4 h-full items-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3"
                    className="text-indigo-500 w-6 h-6 flex-shrink-0 mr-4"
                    viewBox="0 0 24 24"
                  >
                    <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
                    <path d="M22 4L12 14.01l-3-3"></path>
                  </svg>
                  <span className="title-font font-medium">
                    Možnosť využitia ako medziplodiny v teplejších a humídnych
                    podmienkach
                  </span>
                </div>
              </div>
            </div>
          </div>
          <img
            alt="Hybrid kukurice Pyroxenia"
            className="lg:w-1/2 w-full lg:h-auto h-64 object-cover object-center rounded"
            src={Obr}
          />
        </div>
      </div>
    </section>

    <div className="lg:w-2/3 w-full mx-auto overflow-auto py-4 mb-6">
      <h2 className="text-2xl text-gray-900 text-center font-medium leading-none py-4 mb-6 mt-2">
        Výsledky v ŠOŠ SR za roky 2006 – 2007 (priemer lokalít) :
      </h2>

      <table className="table-auto w-full text-left whitespace-no-wrap py-2">
        <tbody>
          <tr>
            <td
              className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400 rounded-tl rounded-bl border-2"
              rowspan="2"
            >
              Hybrid
            </td>
            <td
              className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400 rounded-tl rounded-bl border-2"
              colspan="3"
            >
              Úroda suchých šúľkov (t/ha){" "}
            </td>
            <td
              className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400 rounded-tl rounded-bl border-2"
              colspan="3"
            >
              Sušina zrna (%)
            </td>
          </tr>
          <tr>
            <td className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400 rounded-tl rounded-bl border-2">
              2006
            </td>
            <td className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400 rounded-tl rounded-bl border-2">
              2007
            </td>
            <td className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400 rounded-tl rounded-bl border-2">
              Priemer
            </td>
            <td className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400 rounded-tl rounded-bl border-2">
              2006
            </td>
            <td className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400 rounded-tl rounded-bl border-2">
              2007
            </td>
            <td className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400 rounded-tl rounded-bl border-2">
              Priemer
            </td>
          </tr>
          <tr>
            <td className="px-4 py-3">PYROXENIA</td>
            <td className="bg-gray-100 px-4 py-3 ">6,65</td>
            <td className="bg-gray-100 px-4 py-3 ">8,36</td>
            <td className="bg-gray-100 px-4 py-3 ">7,51</td>
            <td className="bg-gray-100 px-4 py-3 ">46,90</td>
            <td className="bg-gray-100 px-4 py-3 ">56,80</td>
            <td className="bg-gray-100 px-4 py-3 ">51,90</td>
          </tr>
          <tr>
            <td className="px-4 py-3 bg-gray-300">Priemer kontrol </td>
            <td className="px-4 py-3 bg-gray-300">7,09</td>
            <td className="px-4 py-3 bg-gray-300">7,48</td>
            <td className="px-4 py-3 bg-gray-300">7,28</td>
            <td className="px-4 py-3 bg-gray-300">42,70</td>
            <td className="px-4 py-3 bg-gray-300">50,40</td>
            <td className="px-4 py-3 bg-gray-300">46,55</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div className="lg:w-2/3 w-full mx-auto overflow-auto py-4 mb-6">
      <h2 className="text-2xl text-gray-900 text-center font-medium leading-none py-4 mb-6 mt-2">
        Výsledky v ŠOŠ SR v roku 2007 v Spišskej Belej (horská oblasť) :
      </h2>

      <table className="table-auto w-full text-left whitespace-no-wrap py-2">
        <thead>
          <tr>
            <th className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400 rounded-tl rounded-bl">
              Úroda
            </th>
            <th className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400">
              PYROXENIA
            </th>
            <th className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400">
              LG 3225
            </th>
            <th className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400">
              INKA
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="px-4 py-3 "> suchých šúľkov (t/ha)</td>
            <td className="bg-gray-100 px-4 py-3 ">8,42</td>
            <td className="px-4 py-3">8,23</td>
            <td className="px-4 py-3">8,12</td>
          </tr>
          <tr>
            <td className="px-4 py-3 bg-gray-300"> Sušina zrna (%)</td>
            <td className="bg-gray-100 px-4 py-3 ">52</td>
            <td className="px-4 py-3 bg-gray-300">37</td>
            <td className="px-4 py-3 bg-gray-300">43</td>
          </tr>
        </tbody>
      </table>
    </div>
  </Layout>
)

export default SecondPage
